import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './MemberEntry.scss';
import { Avatar as IAvatar } from '@wix/chat-web';
import Avatar from '../../../Avatar/Avatar';

interface MemberEntryProps {
  id: string;
  name: string;
  avatar: IAvatar;
  onSelect?(id: string): any;
  entrySuffix?: ReactElement;
  badges?: (ReactElement | string)[];
}

class MemberEntry extends React.Component<MemberEntryProps> {
  handleClick = () => {
    const { onSelect, id } = this.props;
    onSelect && onSelect(id);
  };

  render() {
    const { name, avatar, entrySuffix, onSelect, badges } = this.props;

    return (
      <div
        className={classNames(styles.entry, { [styles.clickable]: onSelect })}
        onClick={this.handleClick}
      >
        <div className={styles.avatar}>
          <Avatar avatar={avatar} size={36} />
        </div>
        <div className={styles.withUnderLine}>
          <span className={styles.name} data-hook="name">
            {name}
          </span>
          {badges && badges.length ? (
            <div className={styles.badges} data-hook="badges">
              {badges.map((badge, index) => (
                <div key={index} data-hook="badge">
                  {badge}
                </div>
              ))}
            </div>
          ) : undefined}
        </div>
        <div data-hook="suffix">{entrySuffix}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(MemberEntry);
